module.exports = __webpack_public_path__ + "static/media/utensil-knife.d6817ad8.svg";